import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { CarteiraProfissionalService } from '@/core/api/sicom-api/servicos/pessoa-fisica/carteira-profissional/carteira-profissional.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { CarteiraProfissionalRequest, CarteiraProfissionalResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/carteira-profissional/carteira-profissional.model';

@Injectable({ providedIn: 'root' })
export class CarteiraProfissionalServicosService {
    constructor(
        private api: CarteiraProfissionalService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: CarteiraProfissionalRequest, context?: HttpContext): Observable<CarteiraProfissionalResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
